import React from 'react'
import { RegisterItem } from '@core/entities/register/RegisterItem'
import { Timeline } from '@common/Timeline'
import { useGetRegisterItemTimeline } from '@core/react-query/features/registers/registers/register/items/item'

type RegisterItemDetailsTimelineTabProps = {
  registerId: number
  registerItemId: number
  registerItem: RegisterItem
}

export const RegisterItemDetailsTimelineTab: React.FC<
  RegisterItemDetailsTimelineTabProps
> = ({ registerItem, registerId, registerItemId }) => {
  const {
    data: timelinePage,
    isLoading: registerItemTimelineLoading,
    isError: registerItemTimelineError,
  } = useGetRegisterItemTimeline({
    registerId,
    registerItemId,
    size: 1000,
  })

  return (
    <>
      <ErrorMessage>{registerItemTimelineError}</ErrorMessage>
      <Timeline
        isLoading={registerItemTimelineLoading}
        auditResults={timelinePage}
        registerItem={registerItem}
        scope={'REGISTER_ITEM'}
      />
    </>
  )
}
